import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services';
import { constants } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class NoAuthGuard {
  constructor(
    private router: Router,
    private authService: AuthService,
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.authService.activeSession()) {
      return true;
    }

    this.router.navigate([constants.HOME_ROUTE], { skipLocationChange: false }).then(() => {
      this.pageReload();
    });

    return false;
  }

  pageReload() {
    location.reload();
  }
}
